export default __webpack_public_path__ + "cc02432784f60fa4c3cd35b7112681fb.svg";